import SetPermissionModal1 from './set-permission-modal1.vue'
export default SetPermissionModal1
